/*
 * @Descripttion: 
 * @version: 
 * @Author: 
 * @Date: 2023-03-17 10:14:14
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-04-20 10:55:35
 */
import service from "./api";

// 用戶實測搜索
export function searchConfirmedMerchant(data) {
    return service({
        url: "/request/user.php",
        method: "POST",
        data: data
    })
}

// 获取商户
export function getConfirmedMerchant(data) {
    return service({
        url: "/request/user.php",
        method: "POST",
        data: data
    })
}

// 语言切换
export function changeLanguages(data) {
    return service({
        url: "/request/user.php",
        method: "POST",
        data: data
    })
}